import {
  FilterMode,
  PaymentReceiptUse_OrderBy,
  PaymentReceiptUse,
  SortOrder,
  PaymentReceiptUse_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const paymentReceiptUseService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.paymentReceiptUseOne({ id });
    return result.paymentReceiptUseOne as PaymentReceiptUse;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: PaymentReceiptUse_OrderBy[] | null = null,
    filter: PaymentReceiptUse_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PaymentReceiptUse_Filter | undefined;
    if (searchValue !== "") {
      where = {
        detail: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.paymentReceiptUseListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ detail: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.paymentReceiptUseListWithOffset
    ) as PaymentReceiptUse[];
    return { list, orderBy };
  },
};
